import { getUuid } from "@/util/algorithmUtil";
import { createSocket } from "@/staticJs/webSocket";
import i18n from "@/i18n/i18n";
import Vue from "vue";
/**
 * 初始化不同公司的参数
 */
export const initCustomerParam = function() {
  let tenantId = "";
  let systemType = "";
  let systemTitle = "";
  let customerAbbreviation = "";
  let customerFullName = "";
  let homeLogoName = "";
  let pageLogoName = "";
  let serviceHotLine = "";
  let provider = "";
  let uuid = getUuid();
  let wechatLogo = "";
  let officialAccountsTip = "";
  let officialAccountsTipTwo = "";
  if (
    window.location.href.includes("www.51obt.com") ||
    window.location.href.includes("114.80.62.203") ||
    window.location.href.includes("114.80.62.205") ||
    window.location.href.includes("localhost") ||
    window.location.href.includes("yucigj")
  ) {
    tenantId = "111";
    systemType = "travel";
    systemTitle = "上海玉瓷";
    customerAbbreviation = "玉瓷";
    customerFullName = "上海玉瓷国际旅行社有限公司";
    homeLogoName = "logo-yuci1";
    pageLogoName = "logo-zongqu";
    wechatLogo = "wechat-code-yuci";
    serviceHotLine = "40069-40069";
    provider = "Copyright 2024-2024 上海玉瓷 备案号：沪ICP备2024093325号";
    officialAccountsTip = "公众号：上海玉瓷";
    officialAccountsTipTwo = "上海玉瓷";
    officialAccountsTip = '公众号：玉瓷商旅';
    officialAccountsTipTwo = '玉瓷商旅';
    /* 纵趣环境 上线纵趣的时候 webSocket 需换成纵趣的地址 */
    if (window.location.href.includes("yucigj")) {
      createSocket(`wss://www.yucigj.com/51obt/web_socket/${uuid}`);
    } else {
      createSocket(`ws://114.80.62.203:8899/51obt/web_socket/${uuid}`);
    }
  }
  if (
    window.location.href.includes("travel.eland-china.com") ||
    window.location.href.includes("103.13.245.71")
  ) {
    tenantId = "111";
    systemType = "enterprise";
    systemTitle = "衣恋差旅";
    customerAbbreviation = "衣恋";
    customerFullName = "衣恋（上海）国际旅行社有限公司";
    homeLogoName = "logo-home-yilian";
    pageLogoName = "logo-yilian";
    wechatLogo = "wechat-code-yilian";
    serviceHotLine = "021-52903171 &nbsp;&nbsp; 021-23079111";
    provider = "沪ICP备16018206号-12";
    officialAccountsTip = i18n.messages[Vue.ls.get("languageType")].A241;
    officialAccountsTipTwo = i18n.messages[Vue.ls.get("languageType")].A242;
    /* 依恋环境 上线依恋的时候 webSocket 需换成依恋的地址 */
    if (window.location.href.includes("https")) {
      createSocket(`wss://travel.eland-china.com/51obt/web_socket/${uuid}`);
    } else {
      createSocket(`ws://103.13.245.71:8899/51obt/web_socket/${uuid}`);
    }
  }
  if (
    window.location.href.includes("www.1travel.cn") ||
    window.location.href.includes("106.15.34.165")
  ) {
    tenantId = "112";
    systemTitle = "壹悠商旅";
    customerAbbreviation = "壹悠";
    customerFullName = "上海壹悠旅游咨询有限公司";
    homeLogoName = "logo-home-yiyou";
    pageLogoName = "logo-yiyou";
    wechatLogo = "wechat-code-yiyou";
    serviceHotLine = "13816366842";
    provider = "1travel.cn 沪ICP备14029324号-1";
    officialAccountsTip = i18n.messages[Vue.ls.get("languageType")].A243;
    officialAccountsTipTwo = i18n.messages[Vue.ls.get("languageType")].A244;
    /* 壹悠环境 上线壹悠的时候 webSocket 需换成壹悠的地址 */
    if (window.location.href.includes("https")) {
      createSocket(`wss://www.1travel.cn/51obt/web_socket/${uuid}`);
    } else {
      createSocket(`ws://106.15.34.165:80/51obt/web_socket/${uuid}`);
    }
  }
  window.sessionStorage.setItem("TENANT-ID", tenantId);
  window.sessionStorage.setItem("systemType", systemType);
  window.sessionStorage.setItem("systemTitle", systemTitle);
  window.sessionStorage.setItem("homeLogoName", homeLogoName);
  window.sessionStorage.setItem("pageLogoName", pageLogoName);
  window.sessionStorage.setItem("customerAbbreviation", customerAbbreviation);
  window.sessionStorage.setItem("customerFullName", customerFullName);
  window.sessionStorage.setItem("serviceHotLine", serviceHotLine);
  window.sessionStorage.setItem("provider", provider);
  window.sessionStorage.setItem("wechatLogo", wechatLogo);
  window.sessionStorage.setItem("officialAccountsTip", officialAccountsTip);
  window.sessionStorage.setItem(
    "officialAccountsTipTwo",
    officialAccountsTipTwo
  );
  document.title = systemTitle;
};

/*  公众号提示 */
export const getOfficialAccountsTip = function() {
  return window.sessionStorage.getItem("officialAccountsTip");
};
export const getOfficialAccountsTipTwo = function() {
  return window.sessionStorage.getItem("officialAccountsTipTwo");
};

/*  微信二维码 */
export const getWechatLogo = function() {
  return window.sessionStorage.getItem("wechatLogo");
};

/*  备案号 */
export const getProvider = function() {
  return window.sessionStorage.getItem("provider");
};

/*  拿到服务热线 */
export const getServiceHotLine = function() {
  return window.sessionStorage.getItem("serviceHotLine");
};
/**
 * 拿到客户简称
 */
export const getCustomerAbbreviation = function() {
  return window.sessionStorage.getItem("customerAbbreviation");
};

/**
 * 拿到home的路径
 */
export const getHomeLogoName = function() {
  return window.sessionStorage.getItem("homeLogoName");
};

/**
 * 拿到页面的图标
 */
export const getPageLogoName = function() {
  return window.sessionStorage.getItem("pageLogoName");
};

/**
 * 拿到systemTitle
 */
export const getSystemTitle = function() {
  return window.sessionStorage.getItem("systemTitle");
};

/**
 * 拿到systemTitle
 */
export const getSystemType = function() {
  return window.sessionStorage.getItem("systemType");
};

/**
 * 拿到租户id
 */
export const getTenantId = function() {
  return window.sessionStorage.getItem("TENANT-ID");
};

/**
 * 拿到客户公司全名
 */
export const getCustomerFullName = function() {
  return window.sessionStorage.getItem("customerFullName");
};



// WEBPACK FOOTER //
// ./src/util/environmentUtil.js